module.exports = __webpack_public_path__ + "media/images/products/blog-desktop-sidephoto-a0dc328b97657b0150a873be8ed8a0a2.png";